import ContentCopyIcon from "@mui/icons-material/ContentCopy"
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile"
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft"
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight"
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import SaveAltIcon from '@mui/icons-material/SaveAlt'
import SaveIcon from "@mui/icons-material/Save"
import {Button} from "@mui/material"
import React from "react"
import {IconTypes} from "../../../../akModel/mbk/mbk-definition"

const ButtonTemplate = ({
    color,
    variant = "contained",
    sx,
    styles,
    size,
    startIcon,
    endIcon,
    loadingPosition,
    loadingIndicator,
    loading,
    disableElevation,
    disabled,
    children,
    buttonText,
    onClick,
    actionType,
    payload,
    widget,
    triggerAction
}) => {

    const handleClick = () => {
        if (onClick) { //TODO: on click wieder entfernen
            onClick(payload)
        } else if (actionType) {
            triggerAction(actionType, {payload, widget})
        }
    }

    const IconsMap = Object.freeze({
        [IconTypes.CONTENTCOPYICON]: (
            <ContentCopyIcon size="24px" />
        ),
        [IconTypes.INSERTDRIVEFILEICON]: (
            <InsertDriveFileIcon size="24px" />
        ),
        [IconTypes.KEYBOARDDOUBLEARROWLEFTICON]: (
            <KeyboardDoubleArrowLeftIcon size="24px" />
        ),
        [IconTypes.SAVEICON]: <SaveIcon size="24px" />,
        [IconTypes.KEYBOARDDOUBLEARROWRIGHTICON]: (
            <KeyboardDoubleArrowRightIcon size="24px" />
        ),
        [IconTypes.SAVEALTICON]: (
            <SaveAltIcon size="24px" />
        ),
        [IconTypes.PLUS]: (
            <AddCircleOutlineIcon size="24px"/>
        )
    })

    return (
        <Button
            color={typeof color === "string" ? color : "primary"}
            variant={typeof variant === "string" ? variant : "contained"}
            sx={sx}
            size={typeof size === "string" ? size : "medium"}
            startIcon={IconsMap[startIcon]}
            endIcon={IconsMap[endIcon]}
            loadingPosition={loadingPosition}
            loadingIndicator={loadingIndicator}
            loading={loading}
            disableElevation={disableElevation}
            disabled={disabled}
            onClick={handleClick}
            fullWidth
            style={styles}
        >
            {buttonText}
            {children}
        </Button>
    )
}


ButtonTemplate.defaultProps = {
    color: "primary",
    variant: "contained",
    sx: {width: "100%"},
    size: "medium",
    startIcon: <></>,
    endIcon: <></>,
    loadingPosition: "center",
    loadingIndicator: <></>,
    loading: false,
    disableElevation: false,
    disabled: false,
    children: <></>,
    buttonText: "",
}

export default ButtonTemplate
